import React from 'react';

export default function ratingToStars(rating, className) {
	let stars = [];
	for (let i = 1; i < 6; i++) {
		let kindOfStar = i <= rating? 'glyphicon glyphicon-star': 'glyphicon glyphicon-star-empty';
		stars.push(<i key={i} className={kindOfStar} />)
	}
	return <div className={className}>{stars}</div>
};


// WEBPACK FOOTER //
// ./src/assets/functions/ratingToStars.js